import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Highlight from "../../../../../Highlight";
import { WorkerWorkcenterPatternGroup } from "./worker-workcenter-pattern-group";

const BORDER_COLOR = "#DEDEDE";

export const WorkerWorkcenterGroup = ({
  patterns,
  startingDay,
  searchedTerm,
}: {
  patterns: {
    [patternId: number]: {
      [workerId: string]: {
        workerInfo: any;
        shiftsByDay: Record<string, any>;
      };
    };
  };
  startingDay: Date;
  searchedTerm: string;
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  const firstWorker = Object.values(patterns)?.[0];
  const firstWorkerInfo = Object.values(firstWorker || {})?.[0]?.workerInfo;
  const workcenterName = firstWorkerInfo?.from?.workCenterName || t("full-time-shifts_work-center");
  const workersCount = Object.values(patterns).reduce(
    (total, pattern) => total + Object.keys(pattern).length,
    0
  );

  return (
    <Box width="100%" sx={{ backgroundColor: "#fff" }}>
      <Box
        sx={{
          position: "sticky",
          top: 64,
          zIndex: 99,
          backgroundColor: "#e3e6ed",
          borderTop: `1px solid ${BORDER_COLOR}`,
          paddingLeft: "12px",
          paddingRight: "16px",
          py: 1,
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          gap: "12px",
          userSelect: "none",
        }}
        onClick={() => {
          setOpen((prev) => !prev);
        }}
      >
        <Box
          sx={{ width: 24, height: 24, display: "flex", alignItems: "center" }}
        >
          {open ? (
            <KeyboardArrowUpIcon sx={{ width: 24, height: 24 }} />
          ) : (
            <KeyboardArrowDownIcon sx={{ width: 24, height: 24 }} />
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Roboto",
              color: "rgba(0,0,0,0.87)",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "21px",
            }}
          >
            <Highlight value={workcenterName} searchText={searchedTerm} />
          </Typography>
          <Typography
            sx={{
              fontFamily: "Roboto",
              fontSize: "13px",
              fontWeight: 400,
              lineHeight: "28px",
              color: "rgba(0,0,0,0.87)",
              marginLeft: "8px",
            }}
          >
            {workersCount !== 1
              ? t("full-time-shifts_worker-count-other", { count: workersCount })
              : t("full-time-shifts_worker-count-one", { count: workersCount })}
          </Typography>
        </Box>
      </Box>

      {open && (
        <>
          {Object.entries(patterns).map(([patternId, workerMap]) => (
            <WorkerWorkcenterPatternGroup
              key={patternId}
              patternId={Number(patternId)}
              workers={Object.values(workerMap)} // array of { workerInfo, shiftsByDay }
              startingDay={startingDay}
              searchedTerm={searchedTerm}
            />
          ))}
        </>
      )}
    </Box>
  );
};
